import "core-js/modules/es.function.name.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f897f47c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "tableAttributeContainer"
};
var _hoisted_2 = {
  slot: "empty"
};
var _hoisted_3 = {
  class: "section"
};
var _hoisted_4 = {
  class: "content has-text-centered"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "No attributes found, Try to connect to map attributes", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Banner = _resolveComponent("Banner");
  var _component_w_tooltip = _resolveComponent("w-tooltip");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_w_icon = _resolveComponent("w-icon");
  var _component_el_table = _resolveComponent("el-table");
  return _openBlock(), _createElementBlock("div", null, [!!_ctx.errorMsg ? (_openBlock(), _createBlock(_component_Banner, {
    key: 0,
    type: "error"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.errorMsg), 1)];
    }),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_table, {
    ref: "tableAttribute",
    data: _ctx.authItemAttribueMapped
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        field: "name",
        label: "SAML Attribute"
      }, {
        default: _withCtx(function (scope) {
          return [_createVNode(_component_w_tooltip, {
            content: scope.row.testValue,
            placement: "bottom",
            effect: "light"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", null, _toDisplayString(scope.row.name), 1)];
            }),
            _: 2
          }, 1032, ["content"])];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        field: "name",
        label: "Map in"
      }, {
        default: _withCtx(function (scope) {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.mapping, function (mapping) {
            return _openBlock(), _createElementBlock("div", {
              key: mapping.type
            }, _toDisplayString(mapping.type), 1);
          }), 128))];
        }),
        _: 1
      }), _createElementVNode("template", _hoisted_2, [_createElementVNode("section", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, [_createVNode(_component_w_icon, {
        icon: "sitemap",
        size: "50px",
        class: "no-attributes-found-icon"
      })]), _hoisted_5])])])];
    }),
    _: 1
  }, 8, ["data"])])]);
}